import { Navigate } from "react-router-dom";
import { getUserRole } from "./getUserRole";

export default function SuperAdminProtected({ children }) {
    let user = null;

    try {
        user = getUserRole()
    } catch (e) {
        user = null;
    }

    // Not logged in → redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // User logged in but NOT a super admin → redirect to unauthorized page
    if (user.role !== "super-admin") {
        return <Navigate to="/unauthorized" replace />;
    }

    // Allowed → show page
    return children;
}
